import React, { useEffect, useState } from "react";
import { View, Platform, TouchableOpacity } from 'react-native';
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, RadioPropsDLSType, TypographyTypeDLS } from "@voltmoney/schema";
import Typography from "../../typography/Typography";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import RadioDLS from "../../radio/RadioDLS";
import TextInput from "../../textInput/TextInput";
import { RegexConfig } from "../constants";
import { getParameters } from "../utils";
const PhoneNumberPage = ({ height, privacyAction, termsAction, action, state, caption, isDisabled = true, triggerAction, OnChangeAction, isValidNumber = false, }) => {
    const [inputValue, setInputValue] = useState("");
    const [currentState, setCurrentState] = useState(InputStateToken.DEFAULT);
    const [isLoading, setLoading] = useState(false);
    const [description, setDescription] = useState("");
    const [disabled, setDisabled] = useState(isDisabled);
    const [checked, setChecked] = useState(true);
    const [validNumber, setValidNumber] = useState(isValidNumber);
    useEffect(() => {
        if (Platform.OS === "web") {
            let params = getParameters(window?.location?.href);
            if (params.user) {
                setInputValue(params?.user);
            }
        }
    }, []);
    let isDarkMode = null;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        isDarkMode = params?.isDarkMode;
    }
    useEffect(() => {
        if (validNumber && checked)
            setDisabled(false);
        else
            setDisabled(true);
    }, [validNumber, checked]);
    useEffect(() => {
        if (state === InputStateToken.ERROR) {
            setDescription(caption.error);
            setDisabled(true);
            setCurrentState(InputStateToken.ERROR);
        }
        else {
            setDescription("");
            setCurrentState(InputStateToken.DEFAULT);
        }
    }, [caption, state]);
    const renderContent = () => {
        return (React.createElement(View, { style: { marginTop: Platform.OS === 'web' ? 24 : 56, padding: 16 } },
            React.createElement(Typography, { label: "Enter your mobile number", typeDLS: TypographyTypeDLS.H3S, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { label: "We\u2019ll send an OTP to verify this number.", typeDLS: TypographyTypeDLS.B1R, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: { marginTop: 32 } },
                React.createElement(TextInput, { onlyNumeric: true, showErrorAnimation: true, extraSpace: 15, showErrorOnFocus: false, isDarkMode: isDarkMode ? true : false, value: inputValue, isFocus: true, regex: RegexConfig.MOBILE, type: InputTypeToken.MOBILE, state: currentState, title: "Mobile number", charLimit: 10, keyboardType: KeyboardTypeToken.numberPad, placeholder: "Enter mobile number", id: 'tf_loginScreen_phoneNumber', onChangeText: async (text) => {
                        setInputValue(text);
                        setCurrentState(InputStateToken.DEFAULT);
                        setDescription("");
                        if (OnChangeAction) {
                            await triggerAction({
                                ...OnChangeAction,
                                payload: {
                                    value: text,
                                    ...action.payload
                                }
                            });
                        }
                        if (text.length >= 10) {
                            setValidNumber(true);
                        }
                        else {
                            setValidNumber(false);
                            setCurrentState(InputStateToken.ERROR);
                            setDescription(caption.error);
                        }
                    }, triggerAction: triggerAction, caption: {
                        error: `${(currentState === InputStateToken.ERROR) ? `${description}` : ``}`
                    } })),
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(ButtonDLSBase, { id: 'bt_loginScreen_continue', sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Continue', onPress: async () => {
                        setLoading(true);
                        if (action) {
                            await triggerAction({
                                ...action,
                                payload: {
                                    value: inputValue,
                                    ...action.payload
                                }
                            });
                        }
                        setLoading(false);
                    }, isDisabled: disabled })),
            React.createElement(View, { style: { marginTop: 24, flexDirection: 'row' } },
                React.createElement(RadioDLS, { id: "rb_loginScreen_check", radioDLSType: RadioPropsDLSType.SQUARE, isChecked: true, size: IconSizeTokens.MD, onPressChecked: () => {
                        setChecked(true);
                    }, onPressUnChecked: () => {
                        setChecked(false);
                    }, color: checked ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginLeft: 4 } },
                    React.createElement(Typography, { label: "By proceeding, I accept the", typeDLS: TypographyTypeDLS.B3R, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        if (termsAction)
                            triggerAction(termsAction);
                    }, hitSlop: { top: 10, bottom: 10, left: 10, right: 10 } },
                    React.createElement(Typography, { id: "txt_loginScreen_termsCondition", label: ` T&C `, typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Primary_100 })),
                React.createElement(View, null,
                    React.createElement(Typography, { label: "and ", typeDLS: TypographyTypeDLS.B3R, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        if (privacyAction)
                            triggerAction(privacyAction);
                    }, hitSlop: { top: 10, bottom: 10, left: 10, right: 10 } },
                    React.createElement(Typography, { id: "txt_loginScreen_privacyPolicy", label: `Privacy policy.`, typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Primary_100 })))));
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White },
        React.createElement(React.Fragment, null, renderContent())));
};
export default PhoneNumberPage;
